<template>
  <div class="p-2">
    <CashoutsComponent v-if="showCashoutsComponent" mobile />
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import CashoutsComponent from './components/Index.vue'
import { localeChanged, localize } from 'vee-validate'
import { locales } from '@/libs/i18n/all-locales'

export default {
  name: 'CashoutsMobile',
  components: {
    CashoutsComponent,
  },
  data() {
    return {
      showCashoutsComponent: false
    }
  },
  created() {
    // Önceki key'leri temizle
    useJwt.setToken(null)
    useJwt.setApiKey(null)

    const token = this.$cookies.get('token')
    const apiKey = this.$cookies.get('api-key')
    const locale = this.$cookies.get('locale')

    // Cookie'den dil geldiyse o dili ayarla
    if (locale) {
      const selectedLocale = locales.find(l => l.locale === locale)

      if (selectedLocale) {
        this.updateLocale(locale)
      }
    }

    if (token && apiKey) {
      useJwt.setToken(token)
      useJwt.setApiKey(apiKey)

      useJwt.getMe()
        .then(response => {
          this.$store.dispatch('auth/updateUser', response.data.body)
        })

      setTimeout(() => {
        this.showCashoutsComponent = true
      }, 33)
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale
      localize(locale)
      localeChanged()
      localStorage.setItem('locale', locale)

      if (locale === 'ar') {
        localStorage.setItem('isRTL', 'on')
      }
      this.$store.commit('appConfig/TOGGLE_RTL', locale === 'ar')

      this.updateLocaleFromServer(locale)
    },
    updateLocaleFromServer(lang) {
      if (lang) {
        useJwt.updateLanguage(lang)
      }
    },
  }
}
</script>
